import angular from 'angular'

import area from './area/area.module'
import railway from './railway/railway.module'

const name = 'rails'

angular.module(name, [
  area,
  railway,
])

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/rails.module.js